import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    authenticated: false,
    admin: false,
    premium: false,
    moderator: false,
    ranking: '',
    balance: 0,
    packageVersion: require('../../package.json').version,
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion
    },
    getUser(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.authenticated;
    },
    getRanking(state) {
      return state.ranking;
    },
    getBalance(state) {
      return state.balance;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setUnread(state, unread) {
      Object.assign(state.user, {'unread': unread});
    },
    setAuthenticated(state, authenticated) {
      state.authenticated = authenticated;
    },
    setAdmin(state, admin) {
      state.admin = admin;
    },
    setPremium(state, premium) {
      state.premium = premium;
    },
    setModerator(state, moderator) {
      state.moderator = moderator;
    },
    setRanking(state, ranking) {
      state.ranking = ranking;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    resetState(state) {
      state.user = {}
      state.authenticated = false;
      state.admin = false;
      state.premium = false;
      state.moderator = false;
      state.ranking = '';
    }
  },
  actions: {},
  modules: {}
});
